import { render, staticRenderFns } from "./updateIcon.vue?vue&type=template&id=da842c2c&"
import script from "./updateIcon.vue?vue&type=script&lang=js&"
export * from "./updateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports